import Client from '../client';
import {
  RetrieveRubikaOrdersRequestBuilder,
  ScheduleOrdersRequestBuilder,
} from '../action-services/action-services';
const token = localStorage.getItem('token') || '';

class ActionRepository {
  actionRetrieveRubikaOrders = async (actions: any) => {
    const makeActionServiceRequest = new RetrieveRubikaOrdersRequestBuilder()
      .data(actions.payload)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeActionServiceRequest);
    return response;
  };
  scheduleOrders = async (actions: any) => {
    const makeActionServiceRequest = new ScheduleOrdersRequestBuilder()
      .params(actions.payload)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeActionServiceRequest);
    return response;
  };
}

export default new ActionRepository();
